// ToDo: переписать, избавиться от undefined
export const parseCategory = (path: string) => {
  const match = path.match(/^(?:\/games|\/)?(?:\/(\w+))?(?:\/page-(\d+))?$/);

  if (!match) {
    return undefined;
  }

  return match[1];
};

export const parsePage = (path: string) => {
  const match = path.match(/page-(\d+)/);

  if (match === null) {
    return 1;
  }

  return Number(match[1]);
};

export const checkIsPathWrong = (path: string) => {
  const match = path.match(/^(?:\/games|\/)?(?:\/(\w+))?(?:\/page-(\d+))?$/);

  return !match;
};
